<template>
    <div class="navigation-menu">
        <navigationhamburger-component></navigationhamburger-component>
        <navigationpanel-component></navigationpanel-component>
    </div>
</template>

<script>
    import NavigationHamburger from './NavigationHamburger'
    import NavigationPanel from './NavigationPanel'

    export default {
        components: {
            'navigationpanel-component': NavigationPanel,
            'navigationhamburger-component': NavigationHamburger
        }
    }
</script>

<style lang="scss">
    .navigation-menu {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// Navigation.vue?14fe465a